import { Injectable } from '@odinjs/odin';
import { Value } from '@philips-internal/oswald-ui-core';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { HttpRequestOptions, HttpResponse } from '@philips-internal/oswald-ui-core/lib/services/http-service';
import { foundationContext } from '@philips-internal/oswald-ui-foundation';

const ESTABLISHMENT_ID_HEADER = 'X-Establishment-Id';
const LANGUAGE_HEADER = 'X-Language';

@Injectable({})
export class BaseService {

  private static getEstablishmentId(): string {
    const establishment = foundationContext.getEstablishment();
    if (!establishment) {
      return '1';
      // Framework v6 work around while waiting for the fix
      //throw Error('Establishment not defined.');
    }
    return establishment.id;
  }

  private static getLanguage(): string {
    const language = foundationContext.getUser()?.language;
    if (!language) {
      // OSWALD- work around while waiting for the fix
      // throw Error('Language not defined.');
      return 'pt-br';
    }
    return language;
  }

  static get<T>(endpoint: string, parameters: Record<string, Value> = {}, options?: HttpRequestOptions): Promise<HttpResponse<T>> {
    parameters = {
      ...parameters,
      [ESTABLISHMENT_ID_HEADER]: this.getEstablishmentId(),
      [LANGUAGE_HEADER]: this.getLanguage(),
    };

    return HttpService.get(endpoint, parameters, options);
  }

  static post<T>(endpoint: string, parameters: Record<string, Value> = {}, options?: HttpRequestOptions): Promise<HttpResponse<T>> {
    parameters = {
      ...parameters,
      [ESTABLISHMENT_ID_HEADER]: this.getEstablishmentId(),
      [LANGUAGE_HEADER]: this.getLanguage(),
    };

    return HttpService.post(endpoint, parameters, options);
  }

  static put<T>(endpoint: string, parameters: Record<string, Value> = {}, options?: HttpRequestOptions): Promise<HttpResponse<T>> {
    parameters = {
      ...parameters,
      [ESTABLISHMENT_ID_HEADER]: this.getEstablishmentId(),
      [LANGUAGE_HEADER]: this.getLanguage(),
    };

    return HttpService.put(endpoint, parameters, options);
  }

  static delete<T>(endpoint: string, parameters: Record<string, Value> = {}, options?: HttpRequestOptions): Promise<HttpResponse<T>> {
    parameters = {
      ...parameters,
      [ESTABLISHMENT_ID_HEADER]: this.getEstablishmentId(),
      [LANGUAGE_HEADER]: this.getLanguage(),
    };

    return HttpService.delete(endpoint, parameters, options);
  }
}
